// Grade de tamanhos (roupa pronta) — espelho de backend/lib/sizeGrid.js.
// Grade = { XXS: 10, XS: 20, ... }: chave presente = tamanho faz parte da grade.
export const SIZES = ['XXS', 'XS', 'S', 'M', 'L'];

export function parseGrid(raw) {
  let obj = raw;
  if (raw == null || raw === '') return {};
  if (typeof raw === 'string') {
    try { obj = JSON.parse(raw); } catch { return {}; }
  }
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {};
  const out = {};
  SIZES.forEach(s => {
    if (!Object.prototype.hasOwnProperty.call(obj, s)) return;
    const v = obj[s];
    // mantém '' enquanto o usuário digita; o backend normaliza para inteiro
    out[s] = v === '' ? '' : (parseInt(v, 10) > 0 ? parseInt(v, 10) : 0);
  });
  return out;
}

export function gridTotal(raw) {
  return Object.values(parseGrid(raw)).reduce((s, n) => s + (parseInt(n, 10) || 0), 0);
}

export function gridText(raw) {
  return Object.entries(parseGrid(raw)).map(([s, n]) => `${s} ${n || 0}`).join(' · ');
}

export const isTechPack = f => f?.category === 'tech_pack';

// ── Cores × tamanhos ────────────────────────────────────────────────────────
// color_grid = [{ color, ref, sizes: { XS: 10, ... } }]. Com cores, a grade por
// tamanho é a soma das cores (o backend recalcula e grava as duas).
export function parseColors(raw) {
  let arr = raw;
  if (raw == null || raw === '') return [];
  if (typeof raw === 'string') {
    try { arr = JSON.parse(raw); } catch { return []; }
  }
  if (!Array.isArray(arr)) return [];
  return arr.filter(c => c && typeof c === 'object')
    .map(c => ({ color: c.color ?? '', ref: c.ref ?? '', sizes: parseGrid(c.sizes) }));
}

export const colorTotal = c => Object.values(c?.sizes || {}).reduce((s, n) => s + (parseInt(n, 10) || 0), 0);
export const colorsTotal = colors => parseColors(colors).reduce((s, c) => s + colorTotal(c), 0);

// Soma por tamanho das cores, só nos tamanhos selecionados
export function sizeTotalsFromColors(colors, selected) {
  const keys = Object.keys(parseGrid(selected));
  return Object.fromEntries(keys.map(k => [k, parseColors(colors).reduce((s, c) => s + (parseInt(c.sizes[k], 10) || 0), 0)]));
}

// Quantidade do item roupa pronta: cores (se houver) ou grade simples
export function garmentQty(item) {
  const colors = parseColors(item?.color_grid);
  return colors.length ? colorsTotal(colors) : gridTotal(item?.size_grid);
}

// Linhas para exibir: com cores, uma por cor; senão a grade por tamanho
export function gridLines(item) {
  const colors = parseColors(item?.color_grid);
  if (colors.length) {
    return colors.map(c => `${c.color || '?'}${c.ref ? ` (${c.ref})` : ''}: ${gridText(c.sizes) || '—'} = ${colorTotal(c)}`);
  }
  const g = gridText(item?.size_grid);
  return g ? [g] : [];
}
